export default {
	load() {
		return {
			fields: {
				request_number: {
					label: "Číslo žiadosti"
				},
				search_name_ico: {
					label: "Obchodné meno / IČO"
				},
				request_state: {
					label: "Stav žiadosti"
				},
				round: {
					label: "Kolo výzvy"
				}
			}
		}
	}
}

